import { render, staticRenderFns } from "./CommunityUnitBusinessNewsCreate.vue?vue&type=template&id=16e45f4c"
import script from "./CommunityUnitBusinessNewsCreate.vue?vue&type=script&lang=js"
export * from "./CommunityUnitBusinessNewsCreate.vue?vue&type=script&lang=js"
import style0 from "./CommunityUnitBusinessNewsCreate.vue?vue&type=style&index=0&id=16e45f4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports